import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EMPTY_STRING } from "../../../constants";

const RichTextEditor = ({
  initialContent,
  onContentChange,
  toolbarOptions,
  readOnly,
  placeholder,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const editorRef = useRef(null);

  useEffect(() => {
    if (initialContent) {
      try {
        const contentState = convertFromRaw(JSON.parse(initialContent));
        setEditorState(EditorState.createWithContent(contentState));
      } catch (error) {
        console.error("Error loading initial content:", error);
      }
    }
  }, [initialContent]);

  const handleEditorChange = (state) => {
    setEditorState(state);
    if (onContentChange) {
      const contentState = state.getCurrentContent();
      const rawContent = JSON.stringify(convertToRaw(contentState));
      onContentChange(rawContent);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (editorRef.current) {
        editorRef.current.focusEditor();
      }
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-100 text-editor">
      <Editor
        ref={editorRef}
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        toolbar={toolbarOptions}
        readOnly={readOnly}
        placeholder={placeholder}
        wrapperClassName="wrapper-class mt-4"
        editorClassName="editor-class"
        toolbarClassName="toolbar-class justify-content-center"
      />
    </div>
  );
};

RichTextEditor.propTypes = {
  initialContent: PropTypes.string,
  onContentChange: PropTypes.func,
  toolbarOptions: PropTypes.object,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
};

RichTextEditor.defaultProps = {
  initialContent: null,
  onContentChange: null,
  toolbarOptions: {
    options: [
      "inline",
      "blockType",
      "fontSize",
      "list",
      "textAlign",
      "link",
      "history",
    ],
  },
  readOnly: false,
  placeholder: EMPTY_STRING,
};

export default RichTextEditor;
